// extracted by mini-css-extract-plugin
var _1 = "CommentComponentStyle-module__comments-list___u6DLj";
var _2 = "CommentComponentStyle-module__comments-list-all___EJazm";
var _3 = "CommentComponentStyle-module__comments-list___u6DLj";
var _4 = "CommentComponentStyle-module__comments-list-all___EJazm";
var _5 = "CommentComponentStyle-module__load-more___Vqqb6";
var _6 = "CommentComponentStyle-module__load-more___Vqqb6";
var _7 = "CommentComponentStyle-module__publish-btn___l10iH";
var _8 = "CommentComponentStyle-module__publish-btn___l10iH";
export { _1 as "comments-list", _2 as "comments-list-all", _3 as "commentsList", _4 as "commentsListAll", _5 as "load-more", _6 as "loadMore", _7 as "publish-btn", _8 as "publishBtn" }
